import React from "react";
import styles from './Checkbox.module.scss';
import PropTypes from "prop-types";

const Checkbox = ({
  label,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className={styles.label}>
      <input
        className={styles.input}
        type="checkbox"
        checked={checked || false}
        onChange={({ target: { checked } })=> {
          onChange(checked);
        }}
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
      />
      {label}
    </label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default Checkbox;
